export default {
    name: 'patient-profile-basic',
    components: {},
    props: {
        patient: Object,
        user_role: String,
        consultation: Object,
        info_personne_a_prevenir: Object
    },
    data() {
        return {
            // can_see_consultation: false
        }
    },
    computed: {

    },
    mounted() {
        // console.log("BSIC: ",this.consultation)
        // if (this.consultation.id > 0) {
        //     this.can_see_consultation == true
        // }
    },
    methods: {

    }
}